var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVsCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9514 60.4985C25.9514 60.4985 23.5158 58.7428 26.4385 56.3985L33.2481 50.3094C33.2481 50.3094 35.1966 48.2595 37.2568 50.0456L100.096 97.6215V120.435C100.096 120.435 100.065 124.018 95.4682 123.622L25.9514 60.4985Z",
    fill: "#2489CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1483 75.2039L25.9514 89.9292C25.9514 89.9292 24.287 91.1673 25.9514 93.3797L33.4714 100.22C33.4714 100.22 35.2575 102.138 37.8961 99.9559L55.0673 86.9354L42.1483 75.2039Z",
    fill: "#1070B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5844 75.3255L100.289 52.6437L100.096 29.9517C100.096 29.9517 98.8275 24.9993 94.5956 27.577L55.0674 63.5533L70.5844 75.3255Z",
    fill: "#0877B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4683 123.652C97.1936 125.418 99.2842 124.84 99.2842 124.84L122.433 113.433C125.396 111.413 124.98 108.907 124.98 108.907V40.7902C124.98 37.7964 121.915 36.7613 121.915 36.7613L101.852 27.0898C97.4676 24.3801 94.5956 27.5769 94.5956 27.5769C94.5956 27.5769 98.2896 24.918 100.096 29.9516V120.019C100.096 120.638 99.9641 121.247 99.7002 121.795C99.1725 122.861 98.0258 123.855 95.2755 123.439L95.4683 123.652Z",
    fill: "#3C99D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsCode);
export default __webpack_public_path__ + "static/media/VSCode.878f1577381c117820709612a1be9c1a.svg";
export { ForwardRef as ReactComponent };